import CompanyImportData from "../components/CompanyImportData";
import useCompanyImportData from "../hooks/useCompanyImportData";

function CompanyImportDataPage() {
    const useCompanyImportDataProps = useCompanyImportData();
    return <CompanyImportData {...useCompanyImportDataProps} />
}

export default CompanyImportDataPage;